module.exports = __webpack_public_path__ + "img/ingredienten-bloemkoolcurry-met-kikkererwten.6684bb32.jpeg";